import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import IconMicrosoft from '~icons/bi/microsoft';

import { Button } from '@adflow/frontend/ui-buttons';

export function MicrosoftLoginButton() {
	const { t } = useTranslation('login');
	const [searchParams] = useSearchParams();

	return (
		<Button
			type="button"
			variant="contained"
			color="primary"
			css={{
				width: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '0.5rem',
				minWidth: '240px',
			}}
			onClick={() => {
				const returnPath = searchParams.get('r');
				const query = new URLSearchParams();
				if (returnPath) query.set('r', returnPath);
				const search = query.size > 0 ? `?${query.toString()}` : '';
				window.location.href = `/api/auth/microsoft${search}`;
			}}
		>
			<IconMicrosoft width={18} height={18} />
			{t('Sign in with Microsoft')}
		</Button>
	);
}
